import { makeStyles } from '@/styles/theme/tss-react';
import type { UniversalEmbedCF } from '@/types';

type Props = Omit<UniversalEmbedCF['fields'], 'snippet'>;

const getJustifyContent = (alignment: Props['alignment']): string => {
  switch (alignment) {
    case 'Left':
      return 'flex-start';
    case 'Right':
      return 'flex-end';
    case 'Center':
      return 'center';
    default:
      return 'center';
  }
};

const useStyles = makeStyles<Props>({ name: 'UniversalEmbed' })(
  ({ breakpoints, brandColors }, props) => {
    const {
      xsMinimumHeight,
      smMinimumHeight,
      mdMinimumHeight,
      lgMinimumHeight,
      xlMinimumHeight,
    } = props;

    const backgroundStyles = {
      Dark: {
        backgroundColor: brandColors.tintsHeroBlue10,
        color: brandColors.tintsOffWhite40,
      },
      Light: {
        backgroundColor: brandColors.tintsOffWhite60,
        color: brandColors.tintsHeroBlue10,
      },
      White: {
        backgroundColor: brandColors.white,
        color: brandColors.tintsHeroBlue10,
      },
    };

    const minHeightStyles = {
      minHeight: xsMinimumHeight ? `${xsMinimumHeight}px` : undefined,
      [breakpoints.up('sm')]: {
        minHeight: smMinimumHeight ? `${smMinimumHeight}px` : undefined,
      },
      [breakpoints.up('md')]: {
        minHeight: mdMinimumHeight ? `${mdMinimumHeight}px` : undefined,
      },
      [breakpoints.up('lg')]: {
        minHeight: lgMinimumHeight ? `${lgMinimumHeight}px` : undefined,
      },
      [breakpoints.up('xl')]: {
        minHeight: xlMinimumHeight ? `${xlMinimumHeight}px` : undefined,
      },
    };

    return {
      container: {
        width: '100%',
        display: 'flex',
        justifyContent: getJustifyContent(props.alignment),
        boxSizing: 'border-box',
        ...backgroundStyles[props.backgroundColor ?? 'White'],
        ...minHeightStyles,
      },
      embedWrapper: {
        width: '100%',
        maxWidth: props.maxWidth ? `${props.maxWidth}px` : '100%',
        overflow: 'auto',
        '& iframe': {
          width: '100%',
          maxWidth: '100%',
        },
      },
      iframe: {
        height: '100%',
      },
    };
  }
);

export default useStyles;
